<template>
  <div>
    <h1 class="journal-title">
      {{ $t('views.journal.title') }}
      <span class="beta">
        βήτα
      </span>
    </h1>
    <div
      class="section-tree-container"
    >
      <JournalSectionTreeItems
        class="mt-4 pl-1"
        :sections="spotlightSections"
        :title="$t('views.journal.sections.spotlight')"
      />
      <JournalSectionTreeItems
        class="pt-4 pl-1"
        :sections="sortedGroupStandaloneSections"
        :title="$t('views.journal.sections.groups')"
      />
      <JournalSectionTreeItems
        class="pt-4 pl-1"
        :sections="sortedUserReflectionSections"
        :title="$t('views.journal.sections.reflections')"
      />
      <JournalSectionTreeItems
        show-add-section
        class="pt-4 pl-1"
        :sections="sortedUserStandaloneSections"
        :title="$t('views.journal.sections.personal')"
      />
    </div>
  </div>
</template>
<script>
import JournalSectionTreeItems from './JournalSectionTreeItems';

export default {
  name: 'JournalSectionsTree',
  components: {
    JournalSectionTreeItems,
  },
  props: {
    userStandaloneSections: {
      type: Array,
      required: true,
    },
    groupStandaloneSections: {
      type: Array,
      required: true,
    },
    userReflectionSections: {
      type: Array,
      required: true,
    },
    spotlightSections: {
      type: Array,
      required: true,
    },
  },
  computed: {
    sortedUserStandaloneSections() {
      return [...this.userStandaloneSections].sort(this.sortByName);
    },
    sortedGroupStandaloneSections() {
      return [...this.groupStandaloneSections].sort(this.sortByName);
    },
    sortedUserReflectionSections() {
      return [...this.userReflectionSections].sort(this.sortByName);
    },
    sortedSpotlightSections() {
      return [...this.spotlightSections].sort(this.sortByName);
    },
  },
  methods: {
    sortByName(sectionA, sectionB) {
      return sectionA.title.localeCompare(sectionB.title);
    },
  },
};
</script>
<style scoped>
.journal-title {
  margin-left: 12px;
  margin-top: 12px;
  font-weight: 500;
  font-size: 28px;
}
.beta {
  font-size: 18px;
  font-weight: 500;
  font-style: oblique;
  color: #3C44C8;
}
.section-tree-container {
  position: relative;
}
.section-tree-container::before {
  border-radius: 25px;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  content: '';
  position: absolute;
  display: block;
  width: 4px;
  background-color: #ccc;
  height: 100%;
}
</style>
